export default () => {
  console.log('INIT FORMS');

  let formContainers = document.querySelectorAll('[form-container]');

  formContainers.forEach((formContainer) => {
    let form = formContainer.querySelector('form');
    let success = formContainer.querySelector('.form-success');
    let error = formContainer.querySelector('.form-error');

    let isSubmitting = false;

    console.log(form, success, error);

    let formRelease = () => {
      isSubmitting = false;
      formContainer.classList.remove('processing');
      formContainer.recaptchaResponse.value = '';
      if (formContainer.recaptchaResponse) {
        formContainer.recaptchaResponse.value;
      }
      if (formContainer.classList.contains('success')) {
        success.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }
      if (formContainer.classList.contains('error')) {
        error.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }

      setTimeout(() => {
        formContainer.classList.remove('success');
        formContainer.classList.remove('error');
      }, 5000);
    };
    const formSubmitted = (e) => {
      e.preventDefault();
      formContainer.classList.add('processing');

      if (isSubmitting) return false;

      isSubmitting = true;

      if (
        formContainer.recaptchaResponse &&
        (formContainer.widget || formContainer.widget === 0) &&
        formContainer.recaptchaResponse.value === ''
      ) {
        grecaptcha
          .execute(formContainer.widget)
          .then(function (token) {
            console.info('token:', token);
            if (token) {
              formContainer.recaptchaResponse.value = token;
              formShipped(e);
            }
          })
          .catch((error) => {
            console.error(error);
            alert('Error sending the form. Please try again.');
            formContainer.classList.add('error');
            formRelease();
          });
      } else {
        formShipped(e);
        return false;
      }
      return false;
    };
    const formShipped = (e) => {
      e.preventDefault();
      /*console.log(
        'recaptchaResponse',
        formContainer.recaptchaResponse,
        formContainer.recaptchaResponse.value,
        formContainer.widget
      );
      console.log(
        'recaptchaResponse.value',
        formContainer.recaptchaResponse.value,
        formContainer.recaptchaResponse.value === ''
      );
      console.log(
        'widget',
        formContainer.widget,
        formContainer.widget || formContainer.widget === 0
      );*/

      let formData = new FormData(form);
      console.log('formData', formData);

      fetch('/', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Contet-Type': 'application/json',
        },
        body: formData,
        redirect: 'manual',
      })
        .then((res) => res.json())
        .then((response) => {
          console.log('RESPONSE', response);
          if (response.success) {
            form.reset();
            formContainer.classList.add('success');
          } else {
            formContainer.classList.add('error');
          }
          formRelease();
        })
        .catch((error) => {
          formContainer.classList.add('error');
          formRelease();
        });
      return false;
    };

    form.addEventListener('submit', formSubmitted);
  });

  window.onRecaptchaloadCallback = () => {
    
    formContainers.forEach((formContainer) => {
      let form = formContainer.querySelector('form');
      let container = formContainer.querySelector('[recaptcha-container]');
      if (container) {
        formContainer.widget = grecaptcha.render(container, {
          sitekey: window.RECAPTCHA_SITE_KEY, // Replace with your site key
          size: 'invisible',
        });
        let response = formContainer.querySelector(
          '[name="g-recaptcha-response"]'
        );
        formContainer.recaptchaResponse = response;
        console.log('response', response);
      }
    });
    /*if(regularForm){
				contactWidget = grecaptcha.render('contact-recaptcha', {
					'sitekey' : '{{RECAPTCHA_SITE_KEY}}',  // Replace with your site key
					'size' : 'invisible',
					'callback' : onContactSubmit
				});
			}
			if(contactForm){
				
				regularWidget = grecaptcha.render('regular-recaptcha', {
					'sitekey' : '{{RECAPTCHA_SITE_KEY}}',
					'size' : 'invisible',
					'callback' : onSubmit
				});
			}*/
  };
};
